import React, { useState, useEffect, useRef } from 'react';

const countries = [
    { name: 'Afghanistan', code: 'AF', dial: '+93', flag: '🇦🇫' },
    { name: 'Albania', code: 'AL', dial: '+355', flag: '🇦🇱' },
    { name: 'Algeria', code: 'DZ', dial: '+213', flag: '🇩🇿' },
    { name: 'Andorra', code: 'AD', dial: '+376', flag: '🇦🇩' },
    { name: 'Angola', code: 'AO', dial: '+244', flag: '🇦🇴' },
    { name: 'Argentina', code: 'AR', dial: '+54', flag: '🇦🇷' },
    { name: 'Armenia', code: 'AM', dial: '+374', flag: '🇦🇲' },
    { name: 'Australia', code: 'AU', dial: '+61', flag: '🇦🇺' },
    { name: 'Austria', code: 'AT', dial: '+43', flag: '🇦🇹' },
    { name: 'Azerbaijan', code: 'AZ', dial: '+994', flag: '🇦🇿' },
    { name: 'Bahamas', code: 'BS', dial: '+1-242', flag: '🇧🇸' },
    { name: 'Bahrain', code: 'BH', dial: '+973', flag: '🇧🇭' },
    { name: 'Bangladesh', code: 'BD', dial: '+880', flag: '🇧🇩' },
    { name: 'Barbados', code: 'BB', dial: '+1-246', flag: '🇧🇧' },
    { name: 'Belarus', code: 'BY', dial: '+375', flag: '🇧🇾' },
    { name: 'Belgium', code: 'BE', dial: '+32', flag: '🇧🇪' },
    { name: 'Belize', code: 'BZ', dial: '+501', flag: '🇧🇿' },
    { name: 'Benin', code: 'BJ', dial: '+229', flag: '🇧🇯' },
    { name: 'Bhutan', code: 'BT', dial: '+975', flag: '🇧🇹' },
    { name: 'Bolivia', code: 'BO', dial: '+591', flag: '🇧🇴' },
    { name: 'Bosnia and Herzegovina', code: 'BA', dial: '+387', flag: '🇧🇦' },
    { name: 'Botswana', code: 'BW', dial: '+267', flag: '🇧🇼' },
    { name: 'Brazil', code: 'BR', dial: '+55', flag: '🇧🇷' },
    { name: 'Brunei', code: 'BN', dial: '+673', flag: '🇧🇳' },
    { name: 'Bulgaria', code: 'BG', dial: '+359', flag: '🇧🇬' },
    { name: 'Burkina Faso', code: 'BF', dial: '+226', flag: '🇧🇫' },
    { name: 'Burundi', code: 'BI', dial: '+257', flag: '🇧🇮' },
    { name: 'Cambodia', code: 'KH', dial: '+855', flag: '🇰🇭' },
    { name: 'Cameroon', code: 'CM', dial: '+237', flag: '🇨🇲' },
    { name: 'Canada', code: 'CA', dial: '+1', flag: '🇨🇦' },
    { name: 'Cape Verde', code: 'CV', dial: '+238', flag: '🇨🇻' },
    { name: 'Central African Republic', code: 'CF', dial: '+236', flag: '🇨🇫' },
    { name: 'Chad', code: 'TD', dial: '+235', flag: '🇹🇩' },
    { name: 'Chile', code: 'CL', dial: '+56', flag: '🇨🇱' },
    { name: 'China', code: 'CN', dial: '+86', flag: '🇨🇳' },
    { name: 'Colombia', code: 'CO', dial: '+57', flag: '🇨🇴' },
    { name: 'Comoros', code: 'KM', dial: '+269', flag: '🇰🇲' },
    { name: 'Congo', code: 'CG', dial: '+242', flag: '🇨🇬' },
    { name: 'Costa Rica', code: 'CR', dial: '+506', flag: '🇨🇷' },
    { name: 'Croatia', code: 'HR', dial: '+385', flag: '🇭🇷' },
    { name: 'Cuba', code: 'CU', dial: '+53', flag: '🇨🇺' },
    { name: 'Cyprus', code: 'CY', dial: '+357', flag: '🇨🇾' },
    { name: 'Czech Republic', code: 'CZ', dial: '+420', flag: '🇨🇿' },
    { name: 'Denmark', code: 'DK', dial: '+45', flag: '🇩🇰' },
    { name: 'Djibouti', code: 'DJ', dial: '+253', flag: '🇩🇯' },
    { name: 'Dominica', code: 'DM', dial: '+1-767', flag: '🇩🇲' },
    { name: 'Dominican Republic', code: 'DO', dial: '+1-809', flag: '🇩🇴' },
    { name: 'Ecuador', code: 'EC', dial: '+593', flag: '🇪🇨' },
    { name: 'Egypt', code: 'EG', dial: '+20', flag: '🇪🇬' },
    { name: 'El Salvador', code: 'SV', dial: '+503', flag: '🇸🇻' },
    { name: 'Equatorial Guinea', code: 'GQ', dial: '+240', flag: '🇬🇶' },
    { name: 'Eritrea', code: 'ER', dial: '+291', flag: '🇪🇷' },
    { name: 'Estonia', code: 'EE', dial: '+372', flag: '🇪🇪' },
    { name: 'Ethiopia', code: 'ET', dial: '+251', flag: '🇪🇹' },
    { name: 'Fiji', code: 'FJ', dial: '+679', flag: '🇫🇯' },
    { name: 'Finland', code: 'FI', dial: '+358', flag: '🇫🇮' },
    { name: 'France', code: 'FR', dial: '+33', flag: '🇫🇷' },
    { name: 'Gabon', code: 'GA', dial: '+241', flag: '🇬🇦' },
    { name: 'Gambia', code: 'GM', dial: '+220', flag: '🇬🇲' },
    { name: 'Georgia', code: 'GE', dial: '+995', flag: '🇬🇪' },
    { name: 'Germany', code: 'DE', dial: '+49', flag: '🇩🇪' },
    { name: 'Ghana', code: 'GH', dial: '+233', flag: '🇬🇭' },
    { name: 'Greece', code: 'GR', dial: '+30', flag: '🇬🇷' },
    { name: 'Grenada', code: 'GD', dial: '+1-473', flag: '🇬🇩' },
    { name: 'Guatemala', code: 'GT', dial: '+502', flag: '🇬🇹' },
    { name: 'Guinea', code: 'GN', dial: '+224', flag: '🇬🇳' },
    { name: 'Guinea-Bissau', code: 'GW', dial: '+245', flag: '🇬🇼' },
    { name: 'Guyana', code: 'GY', dial: '+592', flag: '🇬🇾' },
    { name: 'Haiti', code: 'HT', dial: '+509', flag: '🇭🇹' },
    { name: 'Honduras', code: 'HN', dial: '+504', flag: '🇭🇳' },
    { name: 'Hungary', code: 'HU', dial: '+36', flag: '🇭🇺' },
    { name: 'Iceland', code: 'IS', dial: '+354', flag: '🇮🇸' },
    { name: 'India', code: 'IN', dial: '+91', flag: '🇮🇳' },
    { name: 'Indonesia', code: 'ID', dial: '+62', flag: '🇮🇩' },
    { name: 'Iran', code: 'IR', dial: '+98', flag: '🇮🇷' },
    { name: 'Iraq', code: 'IQ', dial: '+964', flag: '🇮🇶' },
    { name: 'Ireland', code: 'IE', dial: '+353', flag: '🇮🇪' },
    { name: 'Israel', code: 'IL', dial: '+972', flag: '🇮🇱' },
    { name: 'Italy', code: 'IT', dial: '+39', flag: '🇮🇹' },
    { name: 'Ivory Coast', code: 'CI', dial: '+225', flag: '🇨🇮' },
    { name: 'Jamaica', code: 'JM', dial: '+1-876', flag: '🇯🇲' },
    { name: 'Japan', code: 'JP', dial: '+81', flag: '🇯🇵' },
    { name: 'Jordan', code: 'JO', dial: '+962', flag: '🇯🇴' },
    { name: 'Kazakhstan', code: 'KZ', dial: '+7', flag: '🇰🇿' },
    { name: 'Kenya', code: 'KE', dial: '+254', flag: '🇰🇪' },
    { name: 'Kiribati', code: 'KI', dial: '+686', flag: '🇰🇮' },
    { name: 'Kuwait', code: 'KW', dial: '+965', flag: '🇰🇼' },
    { name: 'Kyrgyzstan', code: 'KG', dial: '+996', flag: '🇰🇬' },
    { name: 'Laos', code: 'LA', dial: '+856', flag: '🇱🇦' },
    { name: 'Latvia', code: 'LV', dial: '+371', flag: '🇱🇻' },
    { name: 'Lebanon', code: 'LB', dial: '+961', flag: '🇱🇧' },
    { name: 'Lesotho', code: 'LS', dial: '+266', flag: '🇱🇸' },
    { name: 'Liberia', code: 'LR', dial: '+231', flag: '🇱🇷' },
    { name: 'Libya', code: 'LY', dial: '+218', flag: '🇱🇾' },
    { name: 'Liechtenstein', code: 'LI', dial: '+423', flag: '🇱🇮' },
    { name: 'Lithuania', code: 'LT', dial: '+370', flag: '🇱🇹' },
    { name: 'Luxembourg', code: 'LU', dial: '+352', flag: '🇱🇺' },
    { name: 'Madagascar', code: 'MG', dial: '+261', flag: '🇲🇬' },
    { name: 'Malawi', code: 'MW', dial: '+265', flag: '🇲🇼' },
    { name: 'Malaysia', code: 'MY', dial: '+60', flag: '🇲🇾' },
    { name: 'Maldives', code: 'MV', dial: '+960', flag: '🇲🇻' },
    { name: 'Mali', code: 'ML', dial: '+223', flag: '🇲🇱' },
    { name: 'Malta', code: 'MT', dial: '+356', flag: '🇲🇹' },
    { name: 'Marshall Islands', code: 'MH', dial: '+692', flag: '🇲🇭' },
    { name: 'Mauritania', code: 'MR', dial: '+222', flag: '🇲🇷' },
    { name: 'Mauritius', code: 'MU', dial: '+230', flag: '🇲🇺' },
    { name: 'Mexico', code: 'MX', dial: '+52', flag: '🇲🇽' },
    { name: 'Micronesia', code: 'FM', dial: '+691', flag: '🇫🇲' },
    { name: 'Moldova', code: 'MD', dial: '+373', flag: '🇲🇩' },
    { name: 'Monaco', code: 'MC', dial: '+377', flag: '🇲🇨' },
    { name: 'Mongolia', code: 'MN', dial: '+976', flag: '🇲🇳' },
    { name: 'Montenegro', code: 'ME', dial: '+382', flag: '🇲🇪' },
    { name: 'Morocco', code: 'MA', dial: '+212', flag: '🇲🇦' },
    { name: 'Mozambique', code: 'MZ', dial: '+258', flag: '🇲🇿' },
    { name: 'Myanmar', code: 'MM', dial: '+95', flag: '🇲🇲' },
    { name: 'Namibia', code: 'NA', dial: '+264', flag: '🇳🇦' },
    { name: 'Nauru', code: 'NR', dial: '+674', flag: '🇳🇷' },
    { name: 'Nepal', code: 'NP', dial: '+977', flag: '🇳🇵' },
    { name: 'Netherlands', code: 'NL', dial: '+31', flag: '🇳🇱' },
    { name: 'New Zealand', code: 'NZ', dial: '+64', flag: '🇳🇿' },
    { name: 'Nicaragua', code: 'NI', dial: '+505', flag: '🇳🇮' },
    { name: 'Niger', code: 'NE', dial: '+227', flag: '🇳🇪' },
    { name: 'Nigeria', code: 'NG', dial: '+234', flag: '🇳🇬' },
    { name: 'North Korea', code: 'KP', dial: '+850', flag: '🇰🇵' },
    { name: 'North Macedonia', code: 'MK', dial: '+389', flag: '🇲🇰' },
    { name: 'Norway', code: 'NO', dial: '+47', flag: '🇳🇴' },
    { name: 'Oman', code: 'OM', dial: '+968', flag: '🇴🇲' },
    { name: 'Pakistan', code: 'PK', dial: '+92', flag: '🇵🇰' },
    { name: 'Palau', code: 'PW', dial: '+680', flag: '🇵🇼' },
    { name: 'Palestine', code: 'PS', dial: '+970', flag: '🇵🇸' },
    { name: 'Panama', code: 'PA', dial: '+507', flag: '🇵🇦' },
    { name: 'Papua New Guinea', code: 'PG', dial: '+675', flag: '🇵🇬' },
    { name: 'Paraguay', code: 'PY', dial: '+595', flag: '🇵🇾' },
    { name: 'Peru', code: 'PE', dial: '+51', flag: '🇵🇪' },
    { name: 'Philippines', code: 'PH', dial: '+63', flag: '🇵🇭' },
    { name: 'Poland', code: 'PL', dial: '+48', flag: '🇵🇱' },
    { name: 'Portugal', code: 'PT', dial: '+351', flag: '🇵🇹' },
    { name: 'Qatar', code: 'QA', dial: '+974', flag: '🇶🇦' },
    { name: 'Romania', code: 'RO', dial: '+40', flag: '🇷🇴' },
    { name: 'Russia', code: 'RU', dial: '+7', flag: '🇷🇺' },
    { name: 'Rwanda', code: 'RW', dial: '+250', flag: '🇷🇼' },
    { name: 'Saint Kitts and Nevis', code: 'KN', dial: '+1-869', flag: '🇰🇳' },
    { name: 'Saint Lucia', code: 'LC', dial: '+1-758', flag: '🇱🇨' },
    { name: 'Saint Vincent', code: 'VC', dial: '+1-784', flag: '🇻🇨' },
    { name: 'Samoa', code: 'WS', dial: '+685', flag: '🇼🇸' },
    { name: 'San Marino', code: 'SM', dial: '+378', flag: '🇸🇲' },
    { name: 'Sao Tome and Principe', code: 'ST', dial: '+239', flag: '🇸🇹' },
    { name: 'Saudi Arabia', code: 'SA', dial: '+966', flag: '🇸🇦' },
    { name: 'Senegal', code: 'SN', dial: '+221', flag: '🇸🇳' },
    { name: 'Serbia', code: 'RS', dial: '+381', flag: '🇷🇸' },
    { name: 'Seychelles', code: 'SC', dial: '+248', flag: '🇸🇨' },
    { name: 'Sierra Leone', code: 'SL', dial: '+232', flag: '🇸🇱' },
    { name: 'Singapore', code: 'SG', dial: '+65', flag: '🇸🇬' },
    { name: 'Slovakia', code: 'SK', dial: '+421', flag: '🇸🇰' },
    { name: 'Slovenia', code: 'SI', dial: '+386', flag: '🇸🇮' },
    { name: 'Solomon Islands', code: 'SB', dial: '+677', flag: '🇸🇧' },
    { name: 'Somalia', code: 'SO', dial: '+252', flag: '🇸🇴' },
    { name: 'South Africa', code: 'ZA', dial: '+27', flag: '🇿🇦' },
    { name: 'South Korea', code: 'KR', dial: '+82', flag: '🇰🇷' },
    { name: 'South Sudan', code: 'SS', dial: '+211', flag: '🇸🇸' },
    { name: 'Spain', code: 'ES', dial: '+34', flag: '🇪🇸' },
    { name: 'Sri Lanka', code: 'LK', dial: '+94', flag: '🇱🇰' },
    { name: 'Sudan', code: 'SD', dial: '+249', flag: '🇸🇩' },
    { name: 'Suriname', code: 'SR', dial: '+597', flag: '🇸🇷' },
    { name: 'Sweden', code: 'SE', dial: '+46', flag: '🇸🇪' },
    { name: 'Switzerland', code: 'CH', dial: '+41', flag: '🇨🇭' },
    { name: 'Syria', code: 'SY', dial: '+963', flag: '🇸🇾' },
    { name: 'Taiwan', code: 'TW', dial: '+886', flag: '🇹🇼' },
    { name: 'Tajikistan', code: 'TJ', dial: '+992', flag: '🇹🇯' },
    { name: 'Tanzania', code: 'TZ', dial: '+255', flag: '🇹🇿' },
    { name: 'Thailand', code: 'TH', dial: '+66', flag: '🇹🇭' },
    { name: 'Timor-Leste', code: 'TL', dial: '+670', flag: '🇹🇱' },
    { name: 'Togo', code: 'TG', dial: '+228', flag: '🇹🇬' },
    { name: 'Tonga', code: 'TO', dial: '+676', flag: '🇹🇴' },
    { name: 'Trinidad and Tobago', code: 'TT', dial: '+1-868', flag: '🇹🇹' },
    { name: 'Tunisia', code: 'TN', dial: '+216', flag: '🇹🇳' },
    { name: 'Turkey', code: 'TR', dial: '+90', flag: '🇹🇷' },
    { name: 'Turkmenistan', code: 'TM', dial: '+993', flag: '🇹🇲' },
    { name: 'Tuvalu', code: 'TV', dial: '+688', flag: '🇹🇻' },
    { name: 'Uganda', code: 'UG', dial: '+256', flag: '🇺🇬' },
    { name: 'Ukraine', code: 'UA', dial: '+380', flag: '🇺🇦' },
    { name: 'United Arab Emirates', code: 'AE', dial: '+971', flag: '🇦🇪' },
    { name: 'United Kingdom', code: 'GB', dial: '+44', flag: '🇬🇧' },
    { name: 'United States', code: 'US', dial: '+1', flag: '🇺🇸' },
    { name: 'Uruguay', code: 'UY', dial: '+598', flag: '🇺🇾' },
    { name: 'Uzbekistan', code: 'UZ', dial: '+998', flag: '🇺🇿' },
    { name: 'Vanuatu', code: 'VU', dial: '+678', flag: '🇻🇺' },
    { name: 'Vatican City', code: 'VA', dial: '+379', flag: '🇻🇦' },
    { name: 'Venezuela', code: 'VE', dial: '+58', flag: '🇻🇪' },
    { name: 'Vietnam', code: 'VN', dial: '+84', flag: '🇻🇳' },
    { name: 'Yemen', code: 'YE', dial: '+967', flag: '🇾🇪' },
    { name: 'Zambia', code: 'ZM', dial: '+260', flag: '🇿🇲' },
    { name: 'Zimbabwe', code: 'ZW', dial: '+263', flag: '🇿🇼' },
];

const baseStyles = {
  container: { display: 'flex', gap: '8px', width: '100%', position: 'relative' },
  selector: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    border: '1px solid #ccc',
    borderRadius: 6,
    padding: '8px 10px',
    minWidth: 140,
    background: '#fff',
    cursor: 'pointer',
    userSelect: 'none'
  },
  flag: { fontSize: 18 },
  dial: { color: '#555', fontSize: 14 },
  dropdown: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    left: 0,
    width: 360,
    maxHeight: 260,
    overflowY: 'auto',
    border: '1px solid #ddd',
    borderRadius: 6,
    background: '#fff',
    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
    zIndex: 30
  },
  search: {
    width: '100%',
    padding: '8px 10px',
    border: 'none',
    borderBottom: '1px solid #eee',
    boxSizing: 'border-box',
    outline: 'none',
    fontSize: 14
  },
  countryRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 10px',
    cursor: 'pointer'
  },
  name: { fontSize: 14, color: '#222' },
  smallDial: { fontSize: 13, color: '#666' },
  input: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: 6,
    fontSize: 16,
    boxSizing: 'border-box'
  }
};

export default function PhoneInput({
  value,
  onChange,
  required = false,
  name = 'phone',
  placeholder = '800 000 0000',
  containerStyle = {},
  selectStyle = {},
  inputStyle = {},
  selectWrapperStyle = {},
  inputWrapperStyle = {}
}) {
  const parsePhoneValue = (phoneValue) => {
    const phoneStr = String(phoneValue || '').trim();
    if (!phoneStr) {
      const nigeriaIndex = countries.findIndex(c => c.code === 'NG');
      return { countryIndex: nigeriaIndex !== -1 ? nigeriaIndex : 0, number: '' };
    }
    const cleanPhoneStr = phoneStr.replace(/\s+/g, '');
    const sortedCountries = [...countries].sort((a, b) => b.dial.replace(/\D/g, '').length - a.dial.replace(/\D/g, '').length);
    const matched = sortedCountries.find(c => {
      const cleanDial = c.dial.replace(/\s+/g, '').replace(/-/g, '');
      return cleanPhoneStr.startsWith(cleanDial.replace(/\D/g, ''));
    });
    if (matched) {
      const idx = countries.findIndex(c => c.code === matched.code);
      const cleanDial = matched.dial.replace(/\s+/g, '').replace(/-/g, '');
      const number = phoneStr.replace(new RegExp(`^\\s*${matched.dial.replace(/[-\s]/g, '\\s*')}`), '').trim();
      return { countryIndex: idx, number };
    }
    const nigeriaIndex = countries.findIndex(c => c.code === 'NG');
    return { countryIndex: nigeriaIndex !== -1 ? nigeriaIndex : 0, number: phoneStr };
  };

  const parsed = parsePhoneValue(value);
  const [selectedCountry, setSelectedCountry] = useState(parsed.countryIndex);
  const [phoneNumber, setPhoneNumber] = useState(parsed.number || '');
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [filtered, setFiltered] = useState(countries);
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);

  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    setSelectedCountry(parsed.countryIndex);
    setPhoneNumber(parsed.number || '');
  }, [value]); // sync when external value changes

  useEffect(() => {
    const q = query.trim().toLowerCase();
    // if no query show all
    if (!q) {
      setFiltered(countries);
      return;
    }

    // digits-only part of query (for matching dial codes)
    const digits = q.replace(/\D/g, '');

    const normalized = (s = '') => s.normalize?.('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();

    setFiltered(
      countries.filter(c => {
        const name = normalized(c.name);
        const code = (c.code || '').toLowerCase();
        const dialDigits = (c.dial || '').replace(/\D/g, '');

        // if user typed digits, prefer matching dial codes
        if (digits) {
          return dialDigits.includes(digits) || name.includes(q) || code.includes(q);
        }

        // otherwise match by name or code or dial string
        return name.includes(q) || code.includes(q) || (c.dial || '').toLowerCase().includes(q);
      })
    );
  }, [query]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    setOpen(prev => !prev);
    if (!open) {
      // focus search on open next tick
      setTimeout(() => searchRef.current && searchRef.current.focus(), 50);
    }
  };

  const selectCountry = (index) => {
    setSelectedCountry(index);
    setOpen(false);
    const full = phoneNumber ? `${countries[index].dial} ${phoneNumber}` : '';
    onChange && onChange({ target: { name, value: full } });
  };

  const handleNumberChange = (e) => {
    const cleaned = e.target.value.replace(/\D/g, '');
    setPhoneNumber(cleaned);
    const full = cleaned ? `${countries[selectedCountry].dial} ${cleaned}` : '';
    onChange && onChange({ target: { name, value: full } });
  };

  const current = countries[selectedCountry] || countries[0];

  return (
    <div style={{ ...baseStyles.container, ...containerStyle }} ref={wrapperRef}>
      <div
        role="button"
        tabIndex={0}
        onClick={handleToggle}
        onKeyDown={(e) => { if (e.key === 'Enter') handleToggle(); }}
        style={{ ...baseStyles.selector, ...selectStyle }}
      >
        <span style={baseStyles.flag}>{current.flag}</span>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <span style={baseStyles.name}>{current.name}</span>
          <span style={baseStyles.smallDial}>{current.dial}</span>
        </div>
      </div>

      <div style={{ flex: 1, ...inputWrapperStyle }}>
        <input
          type="tel"
          value={phoneNumber}
          onChange={handleNumberChange}
          placeholder={placeholder}
          required={required}
          inputMode="numeric"
          pattern="[0-9]*"
          style={{ ...baseStyles.input, ...inputStyle }}
        />
      </div>

      {open && (
        <div style={{...baseStyles.dropdown, width: isMobile ? '90vw' : 360, maxWidth: isMobile ? '300px' : '360px' }}>
          <input
            ref={searchRef}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search country name, code or dial..."
            style={baseStyles.search}
          />
          {filtered.map((c, i) => {
            const originalIndex = countries.findIndex(x => x.code === c.code);
            return (
              <div
                key={c.code}
                onClick={() => selectCountry(originalIndex)}
                style={{
                  ...baseStyles.countryRow,
                  background: originalIndex === selectedCountry ? '#f0f7f2' : '#fff'
                }}
              >
                <span style={baseStyles.flag}>{c.flag}</span>
                <div style={{ flex: 1 }}>
                  <div style={baseStyles.name}>{c.name}</div>
                  <div style={{ color: '#666', fontSize: 12 }}>{c.code} • {c.dial}</div>
                </div>
                <div style={{ marginLeft: 8, color: '#333', fontWeight: 600 }}>{c.dial}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
